import {
  asksBuyerForProofOfPayment,
  orderDocumentsUpload,
  useFlag,
} from '@b-stock/fe-core/bstock-next/helpers'
import type { SellerCollectsConfig } from '@b-stock/fe-core/bstock-next/queries'

import useIsLoggedIn from '@/buyer-portal/helpers/useIsLoggedIn'
import { PermissionGranule, usePermission } from '@/helpers/permissions'

/**
 * Whether the "what happens if you win" steps ask the buyer for a proof of
 * payment: the storefront wants one, the Documents upload is live for this
 * listing or order, and the buyer can upload there.
 *
 * One hook for the banner, the bid and Buy Now summaries and the first-win
 * modal, so they cannot disagree. The storefront and rollout rule is fe-core's,
 * shared with the order page's payment card.
 *
 * A signed-in buyer without the upload permission (an account that is not
 * active, or a login on another account than the order's) is not told to
 * upload. A signed-out visitor still is: they can upload once they sign in
 * and win.
 */
export const useAsksForProofOfPayment = (
  config: SellerCollectsConfig | null | undefined,
  target: { storeFrontId?: string | null; sellerCollects?: boolean | null },
  /** The order's buyer account; the login's own account when omitted. */
  buyerAccountId?: string
): boolean => {
  const flagValue = useFlag(orderDocumentsUpload)
  const isLoggedIn = useIsLoggedIn()
  const canUpload = usePermission(
    PermissionGranule.FEBP_ORDER_DOCUMENTS_UPLOAD,
    buyerAccountId
  )

  return (
    (!isLoggedIn || canUpload) &&
    asksBuyerForProofOfPayment(config, target, flagValue)
  )
}
